module.exports = __webpack_public_path__ + "assets/img/es-6fefd281.png";